import React, { Component } from "react";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import { Spin, message, Select,DatePicker } from "antd";
import Bridge from "../../utils/Bridge";
import { ECAS_FORM_TYPES } from "../../utils/consts";
import moment from 'moment';
import dayjs from 'dayjs';

const { Option } = Select

export default class AddPhysicalEcasForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      date:null,
      form_pdf:[],
      eals_id:"",
      speech:"",
      salivation:"",
      swallowing:"",
      handwriting:"",
      cutting_food_a:"",
      cutting_food_b:"",
      dressing_and_hygiene:"",
      turning_in_bed:"",
      walking:"",
      climbing_stairs:"",
      dyspnea:"",
      orthopnea:"",
      respiratory_insufficiency:"",
      ALS_total:"",
    };
  }
  save_form = () => {
    if (!this.state.date) {
      message.warning("Please select date.");
      return;
    }

    // Require either a PDF form or at least one ALSFRS-R score to be present
    const hasFormPdf = this.state.form_pdf && this.state.form_pdf.length > 0;
    const hasScore = [
      "speech",
      "salivation",
      "swallowing",
      "handwriting",
      "cutting_food_a",
      "cutting_food_b",
      "dressing_and_hygiene",
      "turning_in_bed",
      "walking",
      "climbing_stairs",
      "dyspnea",
      "orthopnea",
      "respiratory_insufficiency",
      "ALS_total"
    ].some(key => this.state[key] !== "" && this.state[key] !== null && typeof this.state[key] !== "undefined");

    if (!hasFormPdf && !hasScore) {
      message.warning("Please upload a PDF or fill in at least one ALSFRS-R score.");
      return;
    }

    let formData=new FormData();
    if(this.state.form_pdf.length>0){
      for(let i=0; i<this.state.form_pdf.length; i++){
        formData.append('files[]', this.state.form_pdf[i])
      }
    }

    let date = this.state.date ? moment(this.state.date).format("YYYY-MM-DD hh:mm:ss A") : "";
    
    formData.append('eals_id', localStorage.getItem("ap_eals_id"))
    formData.append('speech', this.state.speech)
    formData.append('salivation', this.state.salivation)
    formData.append('swallowing', this.state.swallowing)
    formData.append('handwriting', this.state.handwriting)
    formData.append('cutting_food_a', this.state.cutting_food_a)
    formData.append('cutting_food_b', this.state.cutting_food_b)
    formData.append('dressing_and_hygiene', this.state.dressing_and_hygiene)
    formData.append('turning_in_bed', this.state.turning_in_bed)
    formData.append('walking', this.state.walking)
    formData.append('climbing_stairs', this.state.climbing_stairs)
    formData.append('dyspnea', this.state.dyspnea)
    formData.append('orthopnea', this.state.orthopnea)
    formData.append('respiratory_insufficiency', this.state.respiratory_insufficiency)
    formData.append('ALS_total', this.state.ALS_total)
    formData.append('date', date)
   
    this.setState({ loading: true });
    Bridge.personal_data_viewer.ecas_study.save_ecas_study_alsfrsr_upload_form(formData)
      .then((response) => {
        if (response.status == "1") {
          message.success(response.message);
          this.setState({
            loading: false,
          },()=>{
            setTimeout(() => {
              window.location.assign("/my-personal-data-viewer");
            }, 2000);
          });
        } else {
          message.warning(response.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.error("Please try againdf!!");
        this.setState({ loading: false });
      });
  };
  onChangeDate = (date, dateString) => {
    this.setState({  date: dateString })
  };
  render() {
    return (
      <div>
        <Header />
        <div
          className="main-content demographics-wrapper physical_ecas_form"
          style={{ paddingTop: 40 }}
        >
          <div className="container" style={{ minHeight: 300 }}>
            <div className="row">
              <div className="col-lg-6">
                <a href="/my-personal-data-viewer" style={{width:95}} className="dashboard-back-arrow mt-0">
                  <box-icon
                    name="chevron-left"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                  Back
                </a>
                <Spin spinning={this.state.loading}>
                  <div className="change-password-form">
                    <h3 className="pb-0 mb-0">Upload ALSFR-R Form</h3>
                    <hr />
                    <div className="form-group mb-4">
                      <label className="input-heading mb-2">
                        Date <span className="text-danger">*</span> 
                      </label>
                      <DatePicker 
                        showTime={true}
                        onChange={this.onChangeDate} 
                        format="MM/DD/YYYY HH:mm"
                        style={{width:"100%"}}
                      />
                    </div>
                    <div className="form-group mb-4">
                      <label className="input-heading mb-2">
                        File &nbsp;
                      </label>
                      <input
                        type={'file'}
                        onChange={(e) =>{
                          this.setState({ form_pdf: e.target.files })
                        }}
                        className="form-control"
                        style={{padding:"11px 22px"}}
                        multiple={true}
                      />
                    </div>
                    <div className="form-group mb-4">
                      <label className="input-heading mb-2">
                        Scores
                      </label>
                      <div className="d-flex justify-content-between align-items-start mt-3">
                        <label className="input-heading mb-2">Speech Score</label>
                        <input
                          type="number"
                          value={this.state.speech}
                          onChange={e => this.setState({ speech: e.target.value })}
                          className="form-control"
                          style={{ padding: "11px 22px", maxWidth: 100 }}
                          min={0}
                          max={4}
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-start mt-3">
                        <label className="input-heading mb-2">Salivation Score</label>
                        <input
                          type="number"
                          value={this.state.salivation}
                          onChange={e => this.setState({ salivation: e.target.value })}
                          className="form-control"
                          style={{ padding: "11px 22px", maxWidth: 100 }}
                          min={0}
                          max={4}
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-start mt-3">
                        <label className="input-heading mb-2">Swallowing Score</label>
                        <input
                          type="number"
                          value={this.state.swallowing}
                          onChange={e => this.setState({ swallowing: e.target.value })}
                          className="form-control"
                          style={{ padding: "11px 22px", maxWidth: 100 }}
                          min={0}
                          max={4}
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-start mt-3">
                        <label className="input-heading mb-2">Handwriting Score</label>
                        <input
                          type="number"
                          value={this.state.handwriting}
                          onChange={e => this.setState({ handwriting: e.target.value })}
                          className="form-control"
                          style={{ padding: "11px 22px", maxWidth: 100 }}
                          min={0}
                          max={4}
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-start mt-3">
                        <label className="input-heading mb-2">Cutting Food (A) Score</label>
                        <input
                          type="number"
                          value={this.state.cutting_food_a}
                          onChange={e => this.setState({ cutting_food_a: e.target.value })}
                          className="form-control"
                          style={{ padding: "11px 22px", maxWidth: 100 }}
                          min={0}
                          max={4}
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-start mt-3">
                        <label className="input-heading mb-2">Cutting Food (B) Score</label>
                        <input
                          type="number"
                          value={this.state.cutting_food_b}
                          onChange={e => this.setState({ cutting_food_b: e.target.value })}
                          className="form-control"
                          style={{ padding: "11px 22px", maxWidth: 100 }}
                          min={0}
                          max={4}
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-start mt-3">
                        <label className="input-heading mb-2">Dressing & Hygiene Score</label>
                        <input
                          type="number"
                          value={this.state.dressing_and_hygiene}
                          onChange={e => this.setState({ dressing_and_hygiene: e.target.value })}
                          className="form-control"
                          style={{ padding: "11px 22px", maxWidth: 100 }}
                          min={0}
                          max={4}
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-start mt-3">
                        <label className="input-heading mb-2">Turning in Bed Score</label>
                        <input
                          type="number"
                          value={this.state.turning_in_bed}
                          onChange={e => this.setState({ turning_in_bed: e.target.value })}
                          className="form-control"
                          style={{ padding: "11px 22px", maxWidth: 100 }}
                          min={0}
                          max={4}
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-start mt-3">
                        <label className="input-heading mb-2">Walking Score</label>
                        <input
                          type="number"
                          value={this.state.walking}
                          onChange={e => this.setState({ walking: e.target.value })}
                          className="form-control"
                          style={{ padding: "11px 22px", maxWidth: 100 }}
                          min={0}
                          max={4}
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-start mt-3">
                        <label className="input-heading mb-2">Climbing Stairs Score</label>
                        <input
                          type="number"
                          value={this.state.climbing_stairs}
                          onChange={e => this.setState({ climbing_stairs: e.target.value })}
                          className="form-control"
                          style={{ padding: "11px 22px", maxWidth: 100 }}
                          min={0}
                          max={4}
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-start mt-3">
                        <label className="input-heading mb-2">Dyspnea Score</label>
                        <input
                          type="number"
                          value={this.state.dyspnea}
                          onChange={e => this.setState({ dyspnea: e.target.value })}
                          className="form-control"
                          style={{ padding: "11px 22px", maxWidth: 100 }}
                          min={0}
                          max={4}
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-start mt-3">
                        <label className="input-heading mb-2">Orthopnea Score</label>
                        <input
                          type="number"
                          value={this.state.orthopnea}
                          onChange={e => this.setState({ orthopnea: e.target.value })}
                          className="form-control"
                          style={{ padding: "11px 22px", maxWidth: 100 }}
                          min={0}
                          max={4}
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-start mt-3">
                        <label className="input-heading mb-2">Respiratory Insufficiency Score</label>
                        <input
                          type="number"
                          value={this.state.respiratory_insufficiency}
                          onChange={e => this.setState({ respiratory_insufficiency: e.target.value })}
                          className="form-control"
                          style={{ padding: "11px 22px", maxWidth: 100 }}
                          min={0}
                          max={4}
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-start mt-3">
                        <label className="input-heading mb-2">ALSFRS-R Total Score</label>
                        <input
                          type="number"
                          value={this.state.ALS_total}
                          onChange={e => this.setState({ ALS_total: e.target.value })}
                          className="form-control"
                          style={{ padding: "11px 22px", maxWidth: 100 }}
                          min={0}
                          max={48}
                        />
                      </div>
                    </div>
                    <button
                      className="submit-button"
                      onClick={() => this.save_form()}
                    >
                      Submit{" "}
                      <box-icon
                        name="chevron-right"
                        color="#fff"
                        style={{ position: "relative", top: 1 }}
                      ></box-icon>
                    </button>
                  </div>
                </Spin>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
